(function () {
  'use strict';

  var page = document.querySelector('[data-bs-page]');
  if (!page) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var gallery = page.querySelector('[data-bs-gallery]');
  var slides = Array.from(page.querySelectorAll('[data-bs-slide]'));
  var thumbs = Array.from(page.querySelectorAll('[data-bs-gallery-thumb]'));
  var dots = Array.from(page.querySelectorAll('[data-bs-gallery-dot]'));
  var galleryCounter = page.querySelector('[data-bs-gallery-counter]');
  var activeSlide = 0;
  var touchStartX = 0;

  function showSlide(index) {
    if (!slides.length) return;
    activeSlide = (index + slides.length) % slides.length;
    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === activeSlide;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    thumbs.forEach(function (thumb, thumbIndex) {
      var active = thumbIndex === activeSlide;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
    dots.forEach(function (dot, dotIndex) {
      var active = dotIndex === activeSlide;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', String(active));
    });
    if (galleryCounter) galleryCounter.textContent = (activeSlide + 1) + ' / ' + slides.length;
  }

  page.querySelector('[data-bs-gallery-prev]')?.addEventListener('click', function () { showSlide(activeSlide - 1); });
  page.querySelector('[data-bs-gallery-next]')?.addEventListener('click', function () { showSlide(activeSlide + 1); });
  thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { showSlide(Number(thumb.dataset.bsGalleryThumb)); }); });
  dots.forEach(function (dot) { dot.addEventListener('click', function () { showSlide(Number(dot.dataset.bsGalleryDot)); }); });
  gallery?.addEventListener('touchstart', function (event) { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
  gallery?.addEventListener('touchend', function (event) {
    var distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) < 42) return;
    showSlide(distance < 0 ? activeSlide + 1 : activeSlide - 1);
  }, { passive: true });

  var dayTabs = Array.from(page.querySelectorAll('[data-bs-day]'));
  var timePanels = Array.from(page.querySelectorAll('[data-bs-time-panel]'));
  var timeButtons = Array.from(page.querySelectorAll('[data-bs-time]'));
  var variantInput = page.querySelector('[data-bs-variant-input]');
  var summary = page.querySelector('[data-bs-summary]');
  var availability = page.querySelector('[data-bs-availability]');
  var addButton = page.querySelector('#BirthdaySocialAddToCart');
  var stickyTime = page.querySelector('[data-bs-sticky-time]');
  var stickySubmit = page.querySelector('[data-bs-sticky-submit]');

  function setDay(day, focusPanel) {
    dayTabs.forEach(function (tab) {
      var active = tab.dataset.bsDay === day;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    timePanels.forEach(function (panel) { panel.hidden = panel.dataset.bsTimePanel !== day; });

    var selectedForDay = timeButtons.find(function (button) {
      return !button.disabled && button.closest('[data-bs-time-panel]').dataset.bsTimePanel === day && button.classList.contains('is-selected');
    });
    var firstAvailable = timeButtons.find(function (button) {
      return !button.disabled && button.closest('[data-bs-time-panel]').dataset.bsTimePanel === day;
    });
    if (!selectedForDay && firstAvailable) selectTime(firstAvailable, false);
    if (focusPanel && (selectedForDay || firstAvailable)) (selectedForDay || firstAvailable).focus();
  }

  function limitedText(inventory) {
    var count = Number(inventory);
    if (count > 0 && count <= 4) return 'Only ' + count + ' ticket' + (count === 1 ? '' : 's') + ' remain at this time';
    return 'Available';
  }

  function selectTime(button, updateUrl) {
    if (!button || button.disabled || button.dataset.available !== 'true') return;
    timeButtons.forEach(function (candidate) {
      var active = candidate === button;
      candidate.classList.toggle('is-selected', active);
      candidate.setAttribute('aria-pressed', String(active));
    });
    if (variantInput) variantInput.value = button.dataset.variantId;
    if (summary) summary.textContent = button.dataset.dateLabel + ' · ' + button.dataset.timeLabel;
    if (availability) availability.textContent = limitedText(button.dataset.inventory);
    if (stickyTime) stickyTime.textContent = button.dataset.timeLabel;
    if (stickySubmit) {
      stickySubmit.disabled = false;
      stickySubmit.textContent = 'Add ticket';
    }
    if (addButton) {
      addButton.disabled = false;
      var text = addButton.querySelector('.add-to-cart-text__content');
      if (text) text.textContent = 'Add ' + button.dataset.timeLabel + ' ticket · $111';
    }
    if (updateUrl && window.history?.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', button.dataset.variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }

  dayTabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { setDay(tab.dataset.bsDay, false); });
    tab.addEventListener('keydown', function (event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      var next = index;
      if (event.key === 'ArrowLeft') next = (index - 1 + dayTabs.length) % dayTabs.length;
      if (event.key === 'ArrowRight') next = (index + 1) % dayTabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = dayTabs.length - 1;
      dayTabs[next].focus();
      setDay(dayTabs[next].dataset.bsDay, false);
    });
  });
  timeButtons.forEach(function (button) { button.addEventListener('click', function () { selectTime(button, true); }); });

  var quantityInput = page.querySelector('[data-bs-quantity-input]');
  function updateQuantity(delta) {
    if (!quantityInput) return;
    var min = Number(quantityInput.min || 1);
    var max = Number(quantityInput.max || 16);
    var value = Math.min(max, Math.max(min, Number(quantityInput.value || min) + delta));
    quantityInput.value = String(value);
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  page.querySelector('[data-bs-quantity-minus]')?.addEventListener('click', function () { updateQuantity(-1); });
  page.querySelector('[data-bs-quantity-plus]')?.addEventListener('click', function () { updateQuantity(1); });
  quantityInput?.addEventListener('change', function () {
    var value = Number(quantityInput.value || 1);
    quantityInput.value = String(Math.min(16, Math.max(1, value)));
  });

  var menuToggle = document.querySelector('[data-bs-menu-toggle]');
  var mobileMenu = document.querySelector('[data-bs-mobile-menu]');
  function normaliseCartBubbleIds() {
    Array.from(document.querySelectorAll('#cart-bubble-text')).slice(1).forEach(function (bubble, index) {
      bubble.id = 'birthday-social-cart-bubble-text-' + (index + 1);
    });
  }
  normaliseCartBubbleIds();
  menuToggle?.addEventListener('click', function () {
    var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!expanded));
    menuToggle.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
    if (mobileMenu) mobileMenu.hidden = expanded;
  });

  var buybox = page.querySelector('[data-bs-buybox]');
  var sticky = page.querySelector('[data-bs-sticky]');
  if (buybox && sticky && 'IntersectionObserver' in window) {
    var buyboxObserver = new IntersectionObserver(function (entries) {
      if (window.innerWidth > 749) { sticky.hidden = true; return; }
      sticky.hidden = entries[0].isIntersecting;
    }, { threshold: .08 });
    buyboxObserver.observe(buybox);
  }
  stickySubmit?.addEventListener('click', function () {
    page.querySelector('.bs-product-form')?.requestSubmit();
  });

  var revealItems = Array.from(page.querySelectorAll('.bs-reveal'));
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach(function (item) { item.classList.add('is-visible'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    revealItems.forEach(function (item) { revealObserver.observe(item); });
  }

  document.addEventListener('cart:update', function (event) {
    normaliseCartBubbleIds();
    if (event.detail?.data?.source !== 'product-form-component' || event.detail?.data?.didError) return;
    window.setTimeout(function () {
      normaliseCartBubbleIds();
      document.querySelector('.bs-header__cart [data-testid="cart-drawer-trigger"]')?.click();
    }, 80);
  });

  var currentTime = timeButtons.find(function (button) { return button.classList.contains('is-selected') && !button.disabled; });
  if (currentTime) selectTime(currentTime, false);
})();
